import { STATUS, useVerifyAction } from '@/providers/VerifyActionProvider';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Divider, Flex, Image, Paper, PinInput, Stack, Text, useMatches } from '@mantine/core';
import Link from 'next/link';
import dividerStyle from './Divider.module.css';
import classes from './Kyc.module.css';
export const KycVerifyEmail: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    successes
  } = useVerifyAction();
  const handleComplete = () => {
    successes.add(STATUS.VERIFY_EMAIL);
  };
  const gap = useMatches({
    sm: 10,
    lg: 5
  });
  return <Flex direction="column" h="100%" p={{
    base: 24,
    sm: 0
  }} align="center" justify={{
    base: 'center',
    lg: 'start'
  }}>
      <Stack hiddenFrom="sm" gap={0}>
        <Text fz={20} className={gunterzBold.className} c="var(--text-dark)" ta="center">
          {i18n._('By completing the steps below you’ll gain a level 2 rank, which grants you UP TO A ')}
          <Text span inherit c="var(--text-prime)">
            {i18n._('1.3x multiplier!')}
          </Text>
        </Text>
        <Divider my={14} classNames={dividerStyle} />
      </Stack>
      <Stack w={{
      sm: 396,
      lg: '100%'
    }} gap={0} align="center" mt={{
      base: 0,
      sm: 40
    }}>
        <Text fz={{
        base: 20,
        md: 25
      }} c="var(--text-dark)" className={gunterzBold.className} style={{
        textWrap: 'nowrap'
      }}>
          {i18n._('VERIFY YOUR EMAIL')}
        </Text>
        <Paper px={20} py={34} mt={40} bd="2px dashed var(--text-prime)" bg="#1A1F26F2" pos="relative">
          <Image src="/assets/kyc/mail_box.svg" alt="mail-box" w={52} h={52} mx="auto" pos="absolute" top={-30} left={0} right={0} />
          <Text fz="lg" c="var(--text-prime)" className={gunterzBold.className} ta="center">
            {i18n._('Check your inbox!')}
          </Text>
          <Text fz="xs" c="var(--text-dark)" tt="uppercase" fw={700} ta="center">
            {i18n._('We’ve sent a ')}
            <Text span inherit c="var(--text-prime)">
              {i18n._('verification link')}
            </Text>
            {i18n._(' to your email. Click the link to confirm IT.')}
          </Text>
        </Paper>

        <Text tt="uppercase" fz="xs" fw={700} c="var(--text-dark)" ta="center" maw={234} mt={{
        base: 24,
        md: 30
      }}>
          {i18n._('OR ENTER THE 6-DIGIT CODE WE SENT TO YOUR E-MAIL HERE:')}
        </Text>

        <PinInput mt={6} type={/^[0-9]*$/} inputMode="numeric" placeholder="-" length={6} size="md" gap={gap} onComplete={handleComplete} classNames={{
        input: classes.input
      }} />

        <Text fz="xs" c="var(--text-dark)" ta="center" mt={20} maw={258}>
          {i18n._('Once verified, your journey to unlock that epic armor continues!')}
        </Text>

        <Divider my={14} classNames={dividerStyle} />

        <Text c="var(--text-dark)" tt="uppercase" fz={{
        base: 10,
        sm: 12,
        lg: 11
      }} fw={700}>
          {i18n._('didn’t receive the code? ')}
          <Text span inherit c="var(--text-blue)" component={Link} href="#" td="underline">
            {i18n._('resend')}
          </Text>
        </Text>
      </Stack>
    </Flex>;
};